document.addEventListener("DOMContentLoaded", function () {

    let currentId = window.wesite.product.selected_or_first_available_variant.id;
    const requiredMetafeldKey = "productSelection";
    const variantMetafields = window.wesite.variant_metafields;
    const selectionName = window.wesite.product_metafields.option4_name;
    const wrapper = document.querySelector(".we-product-options");
    const productForm = document.querySelector(".we-product-form form");
    //const getProductFormFloated = () => document.querySelector(".floated-form .we-product-form form");
    const fixedRandomValue = Math.random().toString(36).substring(2, 15);
    if(!wrapper) return;

    const we_select = {
        selected : 0,
        Price(){
            return this.selected
        }
    }

    window.wesite.prices.add(we_select)


    let enterPageWithBackForwardButton = false;

    try{
        const entries = performance.getEntriesByType("navigation");
        if (entries.length > 0) {
        const entry = entries[0];
        if(entry.type === "back_forward") {
            enterPageWithBackForwardButton = true;
        }
        }
    }catch(error){
        console.error("PerformanceNavigationTiming API not supported.", e);
    }


    async function main(){
        if(enterPageWithBackForwardButton){
            await sleep(250);
        }
        if(variantMetafields[currentId] && variantMetafields[currentId][requiredMetafeldKey]){
            renderProductOptions(".we-product-options",variantMetafields[currentId][requiredMetafeldKey])
        }
        variantChangeListener();
        optionsListener();
        //initFloatedFormListeners();
    }


    function renderProductOptions(selector,data){
        if(!data) return
        const target = document.querySelector(selector);
        const element = createSelectOption(data);
        target.appendChild(element);
    }

    function removeProductFormNode(){
        const element = document.querySelectorAll(".we-custom-node");
        if(!element.length) return
        element.forEach(e => e.remove());
    }

    function addProductFormNode(id,title){
        if(!id) return
        const [element1,element2,element3,element4] = createProductFormNode(id,title);
        productForm.appendChild(element1);
        productForm.appendChild(element2);
        productForm.appendChild(element3);
        productForm.appendChild(element4);

        /*
        const productFormFloated = getProductFormFloated();
        if(!productFormFloated) return;
        const [floatedElement1,floatedElement2,floatedElement3,floatedElement4] = createProductFormNode(id,title);
        productFormFloated.appendChild(floatedElement1);
        productFormFloated.appendChild(floatedElement2);
        productFormFloated.appendChild(floatedElement3);
        productFormFloated.appendChild(floatedElement4);
        */
    }

    function createProductFormNode(id,title){
        const idInput = document.createElement('input');
        idInput.classList.add("we-custom-node");
        idInput.name = `items[1][id]`;
        idInput.value = id;
        idInput.type = 'hidden';
        idInput.setAttribute("data-title",title);

        const propertyInput = document.createElement('input');
        propertyInput.classList.add("we-custom-node");
        propertyInput.name = `items[1][properties][_child]`;
        propertyInput.value = fixedRandomValue;
        propertyInput.type = 'hidden';

        const parentPropertyInput = document.createElement('input');
        parentPropertyInput.classList.add("we-custom-node");
        parentPropertyInput.name = `properties[_parent]`;
        parentPropertyInput.value = fixedRandomValue;
        parentPropertyInput.type = 'hidden';

        const parentPropertyInputTitle = document.createElement('input');
        parentPropertyInputTitle.classList.add("we-custom-node");
        parentPropertyInputTitle.name = `properties[+Extra Produkt]`;
        parentPropertyInputTitle.value = title;
        parentPropertyInputTitle.type = 'hidden';

        return [idInput,propertyInput,parentPropertyInput,parentPropertyInputTitle];
    }

    function createSelectOption(data) {
        const divWrapper = document.createElement("div");
        divWrapper.classList.add("product-form__controls");
        const label = document.createElement("label");
        label.classList.add("product-form__group-name");
        label.innerText = selectionName;
        divWrapper.appendChild(label);
        const innerWrapper = document.createElement("div");
        innerWrapper.classList.add("product-form__controls-group");
        const selectWrapper = document.createElement("div");
        selectWrapper.classList.add("select");
        const select = document.createElement("select");
        select.classList.add("select__select");
        const svg = getSvg();
        selectWrapper.innerHTML = svg;
        selectWrapper.appendChild(select);
    
        data.forEach(function (d,i) {
            if(i === 0){
                const optionElement = document.createElement("option");
                optionElement.value = null;
                optionElement.text = "Extra Produkt auswählen";
                select.appendChild(optionElement);
            }
            const optionElement = document.createElement("option");
            optionElement.value = d.id;
            optionElement.text = d.name + " - " + convertToUIPrice(d.data.variants[0].price) + " €";
            optionElement.setAttribute("data-option", d.id);
            select.appendChild(optionElement);
        });
        innerWrapper.appendChild(selectWrapper);
        divWrapper.appendChild(innerWrapper);
        return divWrapper;
    }


    function getSvg() {
        return `
        <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 20 20" class="icon icon-caret">
            <path d="M9.99996 11.6667L6.66663 8.33333H13.3333L9.99996 11.6667Z" fill="currentColor"></path>
        </svg>
        `;
    }

    function convertToUIPrice(price){
            const newPrice = (price / 100).toFixed(2);  
            let parts = newPrice.split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            if (parts[1] !== undefined) {
            parts[1] = `,${parts[1]}`;
            }
            return parts.join("");
    }

    function optionsListener(){
        const select = wrapper.querySelector("select");
        if(!select) return
        select.addEventListener("change", function(e){
            const selectedOption = e.target.options[e.target.selectedIndex];
            const optionId = selectedOption.getAttribute("data-option");
            const selectedProduct = variantMetafields[currentId][requiredMetafeldKey].find((d) => d.id === optionId);
            removeProductFormNode();
            if(selectedProduct){
                addProductFormNode(selectedProduct.data.variants[0].id,selectedProduct.data.title);
                we_select.selected = selectedProduct.data.variants[0].price;
            } else {
                we_select.selected = 0;
            }
            emitEvent(selectedProduct);
            syncAllOptions(selectedOption.value);
        });
    }

    function floatedOptionsListener(){
        const select = document.querySelector(".floated-form .we-product-options select");
        if(!select) return
        select.addEventListener("change", function(e){
            const selectedOption = e.target.options[e.target.selectedIndex];
            const optionId = selectedOption.getAttribute("data-option");
            const selectedProduct = variantMetafields[currentId][requiredMetafeldKey].find((d) => d.id === optionId);
            removeProductFormNode();
            if(selectedProduct){
                addProductFormNode(selectedProduct.data.variants[0].id, selectedProduct.data.title);
                we_select.selected = selectedProduct.data.variants[0].price;
            } else {
                we_select.selected = 0;
            }
            emitEvent(selectedProduct);
            syncAllOptions(selectedOption.value);
        });
    }

    function syncAllOptions(value){
        syncData(".we-product-options",value);
        //syncData(".floated-form .we-product-options",value);
    }

    function variantChangeListener(){
        document.addEventListener("wesite-variant-change", function(e){
            currentId = e.detail.id;
            we_select.selected = 0
            if(variantMetafields[currentId] && variantMetafields[currentId][requiredMetafeldKey]){
                wrapper.innerHTML = "";
                renderProductOptions(".we-product-options",variantMetafields[currentId][requiredMetafeldKey])
                //renderProductOptions(".floated-form .we-product-options",variantMetafields[currentId][requiredMetafeldKey])
                optionsListener();
                //floatedOptionsListener();
            } else{
                wrapper.innerHTML = "";
                //document.querySelector(".floated-form .we-product-options").innerHTML = "";
            }
        });
    }

    function initFloatedFormListeners() {
        document.addEventListener("floatedFormLoaded", () => {
          renderProductOptions(".floated-form .we-product-options",variantMetafields[currentId][requiredMetafeldKey])
          //floatedOptionsListener();
        });
      }

    function emitEvent(data){
        const event = new CustomEvent("wesite-product-select", {
            detail: {
                data: data
            }
        });
        document.dispatchEvent(event);
    }

    function syncData(target,data) {
          const select = document.querySelector(`${target} .select__select`);
          if (!select) return;
          select.value = data;
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      
    main();
});    